<mat-chip-listbox class="flex flex-wrap gap-4">
  @for (term of searchParams | searchTerms : paramLabelMap; track term) {
    <mat-chip
      class="text-sm flex flex-row justify-between gap-2"
      >
      <div class="flex flex-row items-center gap-1">
        <div class="flex flex-row gap-2">
          <div>{{ term.name }}:</div>
          <div class="font-bold">{{ displayValue(term.value) }}</div>
        </div>
        @if (!term.disabled) {
          <button
            mat-icon-button
            class="flex"
            (click)="remove(term)"
            [disabled]="disabled"
            >
            <mat-icon
              [svgIcon]="'heroicons_solid:x-circle'"
              class="flex icon-size-5"
            ></mat-icon>
          </button>
        }
      </div>
    </mat-chip>
  }
</mat-chip-listbox>
